import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, r = /* @__PURE__ */ o("path", {
  stroke: "#001965",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m12.708 10.025 6.718-6.717 1.767 1.768-6.717 6.717-1.768-1.768ZM2.221 21.836l8.756-10.006 1.695 1.694L2.665 22.28a.25.25 0 0 1-.341-.011l-.53.53.53-.53-.091-.092a.25.25 0 0 1-.012-.341Z"
}, null, -1), c = [
  r
];
function s(l, d) {
  return e(), t("svg", n, [...c]);
}
const a = { render: s };
export {
  a as default,
  s as render
};
